import type { CategoryDefinition } from '@/types';

export const homeCleaningCategories: readonly CategoryDefinition[] = [
  { id: 'home-cleaning.rooms',      name: 'Rooms',      icon: 'home',      color: 'violet', order: 1, description: 'Priced per room' },
  { id: 'home-cleaning.deep-clean', name: 'Deep Clean', icon: 'sparkles',  color: 'purple', order: 2, description: 'Whole-property packages' },
  { id: 'home-cleaning.upholstery', name: 'Upholstery', icon: 'sofa',      color: 'indigo', order: 3, description: 'Fabric, carpet and soft furnishings' },
  { id: 'home-cleaning.move',       name: 'Move',       icon: 'truck',     color: 'blue',   order: 4, description: 'End-of-tenancy and move-in work' },
];
